import { render, staticRenderFns } from "./BookingFor.vue?vue&type=template&id=b32c8104&scoped=true&"
import script from "./BookingFor.vue?vue&type=script&lang=js&"
export * from "./BookingFor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b32c8104",
  null
  
)

export default component.exports